// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"60":"e53a9f95","278":"3fd757c4","329":"95041e59","950":"500b417e"}[chunkId] + ".chunk.js";
};